// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import  'lib-flexible/flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import vueSeamlessScroll from 'vue-seamless-scroll';
import Moment from 'moment';
//中文引入
import 'moment/locale/zh-cn'

// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  //return Moment(value).format('YYYY-MM-DD HH:mm:ss')
  return  Moment(value).calendar();
  //return Moment(value).startOf('hour').fromNow();
})


Vue.use(Vant);
Vue.use(vueSeamlessScroll);
// 完整加载
// import LuckDraw from 'vue-luck-draw'
// Vue.use(LuckDraw)

// 按需引入
// import { LuckyWheel, LuckyGrid } from 'vue-luck-draw'
// Vue.components('LuckyWheel', LuckyWheel)
// Vue.components('LuckyGrid', LuckyGrid)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


// WEBPACK FOOTER //
// ./src/main.js